import { twMerge } from "tailwind-merge";

export const MessageCard: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ children, className, ...rest }) => {
  return (
    <div
      className={twMerge(
        "h-full w-full border-b border-t border-[#EAECF0] bg-base-white shadow-sm md:rounded-xl md:border md:border-grey-light",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};
